import { render, staticRenderFns } from "./CoreSidebarMenus.vue?vue&type=template&id=72a0d9a7&"
import script from "./CoreSidebarMenus.vue?vue&type=script&lang=js&"
export * from "./CoreSidebarMenus.vue?vue&type=script&lang=js&"
import style0 from "./CoreSidebarMenus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports